
define('text!fusion/ui/controls/fusion-checkboxgroup.html',[],function () { return '<div class="fusion-checkboxgroup" data-bind="controlBehavior: { validationObservable: selectedValues }">\r\n\r\n    <h6 class="heading1" data-bind="text: headerText"></h6>\r\n\r\n    <label data-part="validationMessage_PART"></label>\r\n\r\n    <!-- ko transclude -->\r\n    <!-- /ko -->\r\n\r\n</div>\r\n';});

